function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3631 25.6411C15.5584 25.4458 15.875 25.4458 16.0702 25.6411L17.0501 26.621L18.03 25.6411C18.2253 25.4458 18.5418 25.4458 18.7371 25.6411C18.9324 25.8363 18.9324 26.1529 18.7371 26.3482L17.4037 27.6816C17.2084 27.8769 16.8918 27.8769 16.6966 27.6816L15.3631 26.3482C15.1679 26.1529 15.1679 25.8363 15.3631 25.6411Z",
  fill: "#0055FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.051 22.8276C17.3271 22.8276 17.551 23.0515 17.551 23.3276V27.3276C17.551 27.6038 17.3271 27.8276 17.051 27.8276C16.7748 27.8276 16.551 27.6038 16.551 27.3276V23.3276C16.551 23.0515 16.7748 22.8276 17.051 22.8276Z",
  fill: "#0055FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.253 16.5697C20.2543 16.0901 17.4346 18.132 16.9547 21.1307C16.911 21.4034 16.6546 21.589 16.3819 21.5454C16.1093 21.5018 15.9236 21.2453 15.9672 20.9727C16.5344 17.4286 19.8669 15.0155 23.411 15.5823L23.411 15.5823C26.955 16.1494 29.3682 19.482 28.8014 23.026L28.8014 23.0261C28.2342 26.57 24.9018 28.9832 21.3578 28.4165C20.8494 28.3353 20.3528 28.1938 19.8781 27.9952C19.6234 27.8885 19.5033 27.5956 19.61 27.3409C19.7166 27.0861 20.0095 26.9661 20.2642 27.0727C20.6657 27.2407 21.0856 27.3604 21.5154 27.429L21.5156 27.429C24.5143 27.9086 27.334 25.8667 27.8139 22.8681C28.2935 19.8694 26.2517 17.0496 23.253 16.5697Z",
  fill: "#0055FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4472 19.5569V18.7422",
  stroke: "#0055FF",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4472 24.4451V25.2598",
  stroke: "#0055FF",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0335 23.8635C21.2428 24.2209 21.6248 24.4417 22.0389 24.4453H22.9352C23.565 24.4613 24.0885 23.9637 24.1042 23.3339C24.118 22.7889 23.7442 22.3105 23.212 22.1918L21.6853 21.8081C21.0719 21.6645 20.6914 21.0507 20.8351 20.4373C20.957 19.9173 21.4232 19.5515 21.9576 19.5569H22.854C23.2684 19.5598 23.6508 19.7809 23.86 20.1387",
  stroke: "#0055FF",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 20.8335C4.27614 20.8335 4.5 21.0574 4.5 21.3335V24.0001C4.5 25.1972 5.46942 26.1666 6.66656 26.1666H12C12.2761 26.1666 12.5 26.3905 12.5 26.6666C12.5 26.9428 12.2761 27.1666 12 27.1666H6.66656C4.91714 27.1666 3.5 25.7495 3.5 24.0001V21.3335C3.5 21.0574 3.72386 20.8335 4 20.8335Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7791 4C20.7791 3.72386 21.0029 3.5 21.2791 3.5H25.3322C27.0816 3.5 28.4987 4.91714 28.4987 6.66656V13.3331C28.4987 13.6093 28.2749 13.8331 27.9987 13.8331C27.7226 13.8331 27.4987 13.6093 27.4987 13.3331V6.66656C27.4987 5.46942 26.5293 4.5 25.3322 4.5H21.2791C21.0029 4.5 20.7791 4.27614 20.7791 4Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6395 4V8.24256",
  stroke: "black",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.40377 5.10689C5.56128 4.73861 5.92282 4.5 6.3232 4.5L5.40377 5.10689ZM5.40374 5.10697L4.67422 6.81397C4.67421 6.81401 4.67419 6.81405 4.67417 6.81409C4.55927 7.08319 4.5 7.37283 4.5 7.6656V16.1002C4.5 16.6522 4.94757 17.1 5.49984 17.1H12C12.2761 17.1 12.5 17.3239 12.5 17.6C12.5 17.8761 12.2761 18.1 12 18.1H5.49984C4.39515 18.1 3.5 17.2044 3.5 16.1002V7.6656C3.5 7.23777 3.58663 6.8145 3.75457 6.42123L4.48426 4.71383C4.79909 3.97752 5.52233 3.5 6.3232 3.5H14.9558C15.7567 3.5 16.4803 3.97781 16.7948 4.71392C16.7948 4.71393 16.7948 4.71394 16.7948 4.71396L17.5251 6.42283C17.6931 6.8161 17.7797 7.23937 17.7797 7.6672V12C17.7797 12.2761 17.5558 12.5 17.2797 12.5C17.0035 12.5 16.7797 12.2761 16.7797 12V7.6672C16.7797 7.37443 16.7204 7.08478 16.6055 6.81568C16.6055 6.81564 16.6055 6.81561 16.6055 6.81557L15.8752 5.10684C15.7181 4.73898 15.3563 4.5 14.9558 4.5H6.3232",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M17.28 9.57538C17.28 8.83906 16.6832 8.24194 15.9466 8.24194H5.33344C4.59712 8.24194 4 8.83874 4 9.57538",
  stroke: "black",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.63953 15.1206C5.63953 14.8445 5.86338 14.6206 6.13953 14.6206H8.21921C8.49535 14.6206 8.71921 14.8445 8.71921 15.1206C8.71921 15.3967 8.49535 15.6206 8.21921 15.6206H6.13953C5.86338 15.6206 5.63953 15.3967 5.63953 15.1206Z",
  fill: "#0055FF"
});

function SvgLoggiEconomic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = React.forwardRef(SvgLoggiEconomic);
export default __webpack_public_path__ + "static/media/loggi-economic.9f8edc89.svg";
export { ForwardRef as ReactComponent };